<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_5">First Sentient Publications edition 2011</a></p><p class="noindent"><a id="page_5">Copyright © 2024 by Tamarack Song</a></p><a id="page_5">
<p class="noindentc">All rights reserved. This book, or parts thereof, may not be reproduced in any form without</p>
<p class="noindent">permission, except in the case of brief quotations embodied in critical articles and reviews.</p>
<p class="noindentc">A paperback original</p>
</a><p class="noindentc"><a id="page_5">Cover design and book design by Kim Johansen, Black Dog Design, <span class="weblink"></span></a><a href="http://www.blackdogdesign.com" target="_blank"><span class="underline">www.blackdogdesign.com</span></a></p>
<p class="noindentc">Library of Congress Cataloging-in-Publication Data</p>
<p class="noindentc">Song, Tamarack, 1948-</p>
<p class="indenti">Song of trusting the heart : a classic Zen poem for daily meditation /</p>
<p class="noindent">Tamarack Song ; artwork by Jan Zaremba. -- 1st.</p>
<p class="indent">p. cm.</p>
<p class="indentr">Summary: “An adaptation of an ancient Chinese scripture beloved by sages</p>
<p class="noindent">and considered a cornerstone of Zen Buddhism”-- Provided by publisher.</p>
<p class="noindent">ISBN 978-1-59181-175-6 (pbk.)</p>
<p class="noindent">1. Sengcan, d. 606. Xin xin ming. 2. Spiritual life--Zen Buddhism. I.</p>
<p class="noindent">Zaremba, Jan, 1941-II. Sengcan, d. 606. Xin xin ming. English. 2011. III.</p>
<p class="noindent">Title.</p>
<p class="noindent">BQ9288.S463S66 2011</p>
<p class="noindent">294.3'4435--dc23</p>
<p class="noindentB">2011030897</p>
<p class="noindentc">10 9 8 7 6 5 4 3 2 1</p>
<p class="noindent2">SENTIENT PUBLICATIONS, LLC</p>
<p class="noindentB">A Limited Liability Company</p>
<p class="noindentB">1113 Spruce Street</p>
<p class="noindentB">Boulder, CO 80302</p>
<p class="noindentB"><span class="weblink"><a href="http://www.sentientpublications.com" target="_blank"><span class="underline">www.sentientpublications.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?0c91c606